import React from 'react';
import { CONTACT_EMAIL } from '../../../../contact/config';
import ContactForm from '../../../../components/contactForm/contactForm';
import SectionWrapper from '../../../../components/sectionWrapper/sectionWrapper';
import { styles } from './styles';

const TOPICS = ['Feedback', 'Report a bug', 'Account help', 'Report someone'] as const;

export default function Support(): JSX.Element {

  return (
    <SectionWrapper id="support" label="Support" heading="Need help, or have an idea?">
      <div className="pc-split" style={styles.grid}>
        <div>
          <p style={styles.intro}>
            Send it here, or email <a href={`mailto:${CONTACT_EMAIL}`} style={styles.link}>{CONTACT_EMAIL}</a>.
            We reply within one business day.
          </p>
          <ul style={styles.help}>
            <li style={styles.helpItem}>
              <p style={styles.helpTitle}>Can't sign in?</p>
              <p style={styles.helpBody}>
                On the email sign-in screen, tap <span style={styles.inApp}>Need help signing in?</span> to
                recover your email, reset your password or resend your verification link.
              </p>
            </li>
            <li style={styles.helpItem}>
              <p style={styles.helpTitle}>Delete your account</p>
              <p style={styles.helpBody}>
                In the app, go to Settings and choose <span style={styles.inApp}>Delete Account</span>. Can't
                get in? Choose Account help below and we'll delete it for you.
              </p>
            </li>
            <li style={styles.helpItem}>
              <p style={styles.helpTitle}>Report someone</p>
              <p style={styles.helpBody}>
                Choose <span style={styles.inApp}>Report User</span> on their card or in your chat with them,
                or choose Report someone below.
              </p>
            </li>
          </ul>
        </div>
        <ContactForm
          idPrefix="support"
          variant="playercafe"
          emailPlaceholder="you@example.com"
          messagePlaceholder="What happened, or what's on your mind?"
          topics={TOPICS}
          subjectPrefix="[PlayerCafe]"
        />
      </div>
    </SectionWrapper>
  );

}
